<template>
  <div class="spbu-page">
    <div v-if="scrolling" class="sticky-mobile-menu">
      <div class="sticky-mobile-menu__wrapper">
        <ul class="menu">
          <li :class="isOverview ? 'active' : '' "><span @click="scrollMeTo('overview')">Overview</span></li>
          <li :class="isAdvertisement ? 'active' : '' "><span @click="scrollMeTo('advertisement')">Advertisement</span></li>
          <li :class="isAudience ? 'active' : '' "><span @click="scrollMeTo('audience')">Audience</span></li>
          <li :class="isPhotos ? 'active' : '' "><span @click="scrollMeTo('photos')">Photos</span></li>
        </ul>
      </div>
    </div>
    <div class="mobile-banner">
      <div v-if="imgLoaded" class="mobile-banner__action">
        <div v-if="imgLoaded && isPhotosAvailable && detailSlider[0].is360" class="mobile-banner__action__viewphoto-2">
          <button class="btn-regular secondary" @click="toggleBanner(detailSlider)" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
        <div v-else class="mobile-banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggleBanner(detailSlider)" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <div v-else class="mobile-banner__noaction">
        <div class="mobile-banner__noaction__viewphoto">
          <button class="btn-regular secondary" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <div v-if="isPhotosAvailable && detailSlider[0].is360" class="img-overlay">
        <img src="/img/icons/ic_360@2x.png" alt="">
      </div>
      <img :src="isPhotosAvailable ? detailSlider[0].url : placeholderImage[0].url" alt="">
    </div>
    <div class="detail-spbu">
      <!-- Banner photo -->
      <div class="detail-spbu__banner">
        <div v-if="imgLoaded" class="detail-spbu__banner__action">
          <div class="detail-spbu__banner__action__viewphoto">
            <button class="btn-regular secondary" @click="toggleBanner(detailSlider)" :disabled="!isPhotosAvailable">
              View Photos
            </button>
          </div>
        </div>
        <div v-else class="detail-spbu__banner__noaction">
          <div class="detail-spbu__banner__noaction__viewphoto">
            <button class="btn-regular secondary" :disabled="!isPhotosAvailable">
              View Photos
            </button>
          </div>
        </div>
        <adx-detail-slider :class="isPhotosAvailable ? 'detail-spbu__banner__img' : 'detail-spbu__banner__placeholder'" 
        :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage" />
      </div>
      <div v-if="!infoLoaded" class="loading-container">
        <adx-loading />
      </div>
      <div v-else class="detail-spbu__info">
        <div class="detail-spbu__info__left">
          <!-- header title -->
          <div class="detail-spbu__info__left__header">
            <div class="label">
              <adx-label-custom class="spbu" :color="'#ff7444'" :label="'SPBU'"/>
              <adx-label-custom :color="'#ceb521'" :type="'premium'" :label="'Premium'"/>
            </div>
            <h2 class="large-title title">{{spbuDetail.title}}</h2>
            <span class="detail-spbu__info__left__header--placement subhead">{{spbuDetail.location}} . {{spbuDetail.type}}</span>
          </div>
          <!-- tab menu  -->
          <div class="detail-spbu__info__left__wrapper">
            <ul class="menu">
              <li :class="isOverview ? 'active' : '' "><span @click="scrollMeTo('overview')">Overview</span></li>
              <li :class="isAdvertisement ? 'active' : '' "><span @click="scrollMeTo('advertisement')">Advertisement</span></li>
              <li :class="isAudience ? 'active' : '' "><span @click="scrollMeTo('audience')">Audience</span></li>
              <li :class="isPhotos ? 'active' : '' "><span @click="scrollMeTo('photos')">Photos</span></li>
            </ul>
          </div>
          <!-- overview and opertion hour -->
          <div ref="overview" class="detail-spbu__info__left__about">
            <div class="detail-spbu__info__left__about__content" >
              <p :ref="textDesc" class="subhead elipsis" style="visibility: hidden;position: absolute;">{{spbuDetail.description}}</p>
              <div v-if="descHeight>38">
                <div :class="[show? 'default-text': 'hidden']">
                  <p class="subhead elipsis">{{spbuDetail.description}}</p>
                </div>
                <div v-if="!show" class="showButton" @click="showMore(1)">
                  <span class="subhead toggleShow">Read More</span>
                  <i class="icon-chevrondown"></i>
                </div>
                <div v-else class="showButton" @click="showMore(0)">
                  <span class="subhead toggleShow">Read Less</span>
                  <i class="icon-chevronup"></i>
                </div>
              </div>
              <div v-else>
                <div class="default-text">
                  <p class="subhead elipsis">{{spbuDetail.description}}</p>
                </div>
              </div>
              
            </div>
          </div>
          <div class="detail-spbu__info__left__operatinghour" v-if="OperatingHours.length">
            <div class="detail-spbu__info__left__operatinghour__title">
              <span class="regular-font">Operation Hours</span>
            </div>
            <div class="detail-spbu__info__left__operatinghour__content">
              <div class="detail-spbu__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
                <span class="days">{{operatinghour.day}}</span>
                <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
              </div>
            </div>
          </div>
          <!-- package advertisment -->
          <div ref="advertisement" class="detail-spbu__info__left__advertisment">
            <h1>2 AVAILABLE ADVERTISMENT</h1>
            <div class="expandable-level2" v-for="(item, index) in itemMedia" :key="index">
              <adx-expandable-level2 :item="item" :list="location" :viewPhoto="true" 
                @toggleSave="toggleSave" 
                @addToCampaign="addToOrder"
                @previewImage="itemPreview"
              />
            </div>
            <div v-if="admin" class="detail-spbu__info__left__custom-adv">
              <div class="detail-spbu__info__left__custom-adv__header">
                <div class="detail-spbu__info__left__custom-adv__header__title">
                  <span class="strong">Custom Advertisement</span>
                </div>
                <button class="primary btn-regular" @click="toggleCustom(1)">Add To Order</button>
              </div>
            </div>
          </div>
          <!-- audiences - traffic -  demographic -  -->
          <div ref="audience" class="detail-spbu__info__left__traffic">
            <h1>AUDIENCES</h1>
            <div class="detail-spbu__info__left__traffic__title">
              <span class="regular-font">Traffic</span>
            </div>
            <div class="detail-spbu__info__left__traffic__content">
              <span>Monthly Traffic : {{getVisitor | formatNumber}} Visitors</span>
            </div>
             <h1 class="subhead">Demographic</h1>
            <div class="detail-spbu__info__left__traffic__graphic">
              <div class="bar-chart">
                <div class="gender space">
                  <adx-barpercentage class="percentage" :title="`Gender`" :percentageData="genderPercentage" :wrapperStyle="wrapperStyle"/>
                </div>
                <div class="age">
                  <adx-barpercentage class="percentage" :title="`Age`" :percentageData="agePercentage"  :wrapperStyle="wrapperStyle"/>
                </div>
              </div>
            </div>
            <div v-if="traffic.spending" class="detail-spbu__info__left__traffic__content">
              <i class="adx-ic_cards"></i>
              <span class="item">Average Spending  {{traffic.spending | formatMoney}} {{traffic.subject}}</span>
            </div>
            <div v-if="traffic.occupation" class="detail-spbu__info__left__traffic__content">
              <i class="adx-ic_briefcase"></i>
              <span class="item">{{traffic.occupation}}</span>
            </div>
            <div v-if="traffic.visitor_profile" class="detail-spbu__info__left__traffic__content">
              <i class="icon-knowledge-base"></i>
              <span class="item">{{traffic.visitor_profile}}</span>
            </div>
          </div>
          <!-- photos -->
          <div id="photos" ref="photos" class="detail-spbu__info__left__photos">
            <h1>PHOTOS</h1>
            <div v-if="images360.length > 0" class="detail-spbu__info__left__photos__photos-360">
              <h1>360 photos</h1>
              <div class="photo-360">
                <grid-card :min="100" :column="'5'" :gap="8">
                  <template slot="item">
                    <img v-for="(image, index) in images360 " :key="index" class="img-rounded" :src="image.url" alt="" @click="goto360Preview(image.viewer_url)">
                  </template>
                </grid-card>
              </div>
            </div>
            <div v-if="images360.length > 0" class="detail-spbu__info__left__photos__photos-360-mobile">
              <h1>360 photos Mobile</h1>
              <div class="photo-360">
                <grid-card :min="100" :column="'2'" :gap="8">
                  <template slot="item">
                    <img v-for="(image, index) in images360 " :key="index + 'mobile-360' " class="img-rounded" :src="image.url" alt="" @click="goto360Preview(image.viewer_url)">
                  </template>
                </grid-card>
              </div>
            </div>
            <div v-for="(item, index) in itemMedia" :key="index" class="detail-spbu__info__left__photos__reg-photos">
              <div v-if="item.regular_photos.length > 0">
               <h1>{{getPhotoTitle(item.media_name) | capitalizing}}</h1>
                <div>
                  <grid-card :min="100" :column="'5'" :gap="8">
                    <template slot="item">
                      <img v-for="(image, index) in item.regular_photos" :key="index" class="img-rounded" :src="image.thumb_100" alt="" @click="regularPreview(1, item.regular_photos, index)" >
                    </template>
                  </grid-card>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in itemMedia" :key="index + 'mobile-reg'" class="detail-spbu__info__left__photos__reg-photos-mobile">
              <div v-if="item.regular_photos.length > 0">
                <h1>{{getPhotoTitle(item.media_name) | capitalizing}}</h1>
                <div>
                  <grid-card :min="100" :column="'2'" :gap="8">
                    <template slot="item">
                      <img v-for="(image, index) in item.regular_photos" :key="index" class="img-rounded" :src="image.thumb_100" alt="" @click="regularPreview(1, item.regular_photos, index)" >
                    </template>
                  </grid-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- right section content -->
        <div class="detail-spbu__info__right">
          <div class="detail-spbu__info__right__forbidden">
            <div class="detail-spbu__info__right__forbidden--title">
              <i class="icon-warning"></i>
              <span>Forbidden Advertisement</span>
            </div>
            <div v-for="(item, index) in itemMedia" :key="index" class="detail-spbu__info__right__wrapper">
              <div v-if="item.forbidden_ads">
                <h1>{{item.placement}} - {{getPhotoTitle(item.media_name)}}</h1>
                <div class="detail-spbu__info__right__wrapper--content">
                  <p>{{item.forbidden_ads}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-spbu__info__right__address">
            <div class="detail-spbu__info__right__address--title">
              <i class="icon-pin"></i>
              <span>Address</span>
            </div>
            <div class="detail-spbu__info__right__address--content">
              <p>{{spbuDetail.address}}</p>
            </div>
          </div>
          <div class="detail-spbu__info__right__address">
            <div class="detail-spbu__info__right__address--title">
              <i class="icon-building"></i>
              <span>Surrounding</span>
            </div>
            <div class="detail-spbu__info__right__address--content">
              <p>{{spbuDetail.surrounding}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- modal image in advertisment item -->
      <adx-modal
        v-if="isPreview"
        type="full"
        @modal-close="togglePreview">
        <div slot="content" class="preview">
          <div :class="['preview__content']">
            <div class="item">
              <div class="preview__content__slide">
                <div :class="['img-preview', content.orientation]" :style="{backgroundImage: 'url(' + content.imgUrl + ')'}"></div>
              </div>
            </div>
          </div>
        </div>
      </adx-modal>
    </div>
    <!-- modal preview regular photo -->
    <adx-modal v-if="isPreviewModal" @modal-close="regularPreview(0)" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="regularPhoto" :imageIndex="imageIndex" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{spbuDetail.title}}</span>
        </div>
      </div>
    </adx-modal>
    <!-- <div class="contact-us">
      <button class="btn-regular secondary" @click="saved">
        <span class="strong">About, Terms, Contact Us</span>
      </button>
    </div> -->
    <!-- custom advertisment modal -->
    <adx-modal v-if="openCustom" @modal-close="toggleCustom(0)" :type="'small'" :title="'Add Custom Advertisment'">
      <div slot="content" class="content">
        <div class="form">
          <adx-input class="input" :label="`Advertisment Name`" :value.sync="customAdv.title" />
          <adx-textarea class="text-area" :label="`Descriptions`" :value.sync="customAdv.description"/>
          <adx-input :label="`Price`" :value.sync="customAdv.price" />
        </div>
        <div class="button">
          <button class="btn-block secondary cancel" @click="toggleCustom(0)">Cancel</button>
          <button class="btn-block primary" @click="saved">Save</button>
        </div>
      </div>
    </adx-modal>
    <!-- order summary modal -->
    <div v-if="isviewOrder" class="order-summary">
      <div><i class="icon-close" @click="toggleOrder(0)"></i></div>
      <div class="order-summary__wrapper">
        <h1 class="medium-title title">Order Summary</h1>
        <div class="period" v-if="isExBranding"><adx-selectdropdown class="dropdown" :label="`Period of Campaign`" :value.sync="monthlyPeriod" :options="period" /></div>
        <div class="order-summary__wrapper__top" v-if="selectedOrders.length">
            <div class="calendar first">
                <label class="small-font">Start Date</label>
              <v-date-picker
                v-model='startDate'
                :min-date='nextweek'
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                class='date-input'>
                <input
                  class="calendar-start"
                  placeholder= "DD/MM/YYYY"
                  type='text'
                  slot-scope='{ inputValue, updateValue }'
                  :value='inputValue'
                  ref="startDate"
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
            </div>
           <div class="calendar" :class="[ isExBranding ? 'disabled-calender' : '']">
              <label class="small-font">End Date</label>
            <v-date-picker 
              v-model='endDate'
              :min-date='startDate > nextweek ? startDate : nextweek'
              :popoverVisibility="isExBranding? 'hidden':'focus'"
              :theme-styles='themeStyles'
              class='date-input'
              :class="[ isExBranding ? 'disable-input' : '']">
              <input 
                class="calendar-start "
                placeholder= "DD/MM/YYYY"
                type='text'
                :hidePopover="true"
                slot-scope='{ inputValue, updateValue }'
                disabled
                :value='inputValue'
                ref="endDate"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
        </div>
        <div class="order-summary__wrapper__order">
          <div v-for="(order, index) in selectedOrders" :key="index" class="order-summary__wrapper__order__content">
            <div class="detail">
              <div class="detail__left">
                <span class="icon"  @click="deleteOrder(index)"><i class="icon-deleted"></i></span>
                <div class="item-detail">
                  <h1>{{order.title}}</h1>
                  <span>{{order.media_name}}</span>
                </div>
              </div>
              <div class="detail__right">
                <span>{{ order.price | formatMoney}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="order-summary__wrapper__price">
          <div class="ppn">
            <h1>PPN 10%</h1>
            <h1 class="ppn-price">{{ (0.1 * getTotal())  | formatMoney}}</h1>
          </div>
          <div class="ppn-title">
            <h1>Total Order</h1>
          </div>
          <div class="total-order">
            <span>{{ getTotalByPPN() | formatMoney}}</span>
          </div>
        </div>
        <div class="order-summary__wrapper__mobile-button">
          <button class="btn-block primary" :disabled="selectedOrders.length < 1" @click="saved">Continue</button>
        </div>
      </div>
    </div>
    <!-- sticky footer -->
    <div class="footer-spbu">
      <div v-if="!isAddOrder" class="footer-spbu__wrapper">
        <div class="footer-spbu__wrapper__left">
          <h1>{{itemMedia.length}} AVAILABLE ADVERTISEMENT</h1>
        </div>
        <div class="footer-spbu__wrapper__right">
          <div class="footer-spbu__wrapper__right__total-price">
            <div class="header">
              <span>Price per month start from</span>
            </div>
            <div class="header-mobile">
              <span>Price Starting </span>
            </div>
            <div class="price">
              <span>{{ 15000000 | formatMoney}}</span>
            </div>
            <div class="price-mobile">
              <span>per month</span>
            </div>
          </div>
          <div class="footer-spbu__wrapper__right__select-adv">
            <div class="add-desktop"><button class="btn-large primary" @click="scrollMeTo('advertisement')">Select Advertisement</button></div>
            <div class="add-mobile"><button class="btn-large primary" @click="scrollMeTo('advertisement')">View Advertisement</button></div>
          </div>
        </div>
      </div>
      <div v-else class="footer-spbu__wrapper-2">
        <div class="footer-spbu__wrapper-2__left">
          <span>You have {{selectedOrders.length}} item in order</span>
        </div>
        <div class="footer-spbu__wrapper-2__right">
          <div class="footer-spbu__wrapper__right__total-price">
            <div class="header">
              <span>Total Order</span>
            </div>
            <div class="price">
              <span>{{ getTotalByPPN() | formatMoney}}</span>
            </div>
          </div>
          <div class="footer-spbu__wrapper__right__select-adv">
            <div class="view"><button class="btn-large secondary view" @click="toggleOrder(1)">View Order</button></div>
            <div><button class="btn-large primary"  :disabled="selectedOrders.length < 1" @click="saved">Continue</button></div>
          </div>
        </div>
        <div class="footer-spbu__wrapper-2__view-order">
          <button class="btn-block primary" @click="toggleOrder(1)">
            <span>View Order</span>
            <span>{{selectedOrders.length}} item</span>
            <span>{{getTotalByPPN() | formatMoney}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import GridCard from '@/components/Grid/Card'
import Textarea from '@/components/Form/TextArea'
import ListItem from '@/components/ListDemographic'
import BarPercentage from '@/components/BarPercentage'
import LoadingPrimary from '@/components/Loading/Primary'
import DetailSlider from '@/components/Slider/DetailSlider'
import SelectDropdown from '@/components/Form/SelectDropdown'
import LabelStatusCustom from '@/components/StatusLabelCustom'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import ExpandableLevel2 from '@/components/ExpandableListItems/Level2'

import api from '@/api'
import calendar from 'v-calendar'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import * as validationLib from '@/lib/validation/'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-detail-spbu',
  components: {
    'adx-modal': Modal,
    'adx-input': Input,
    'grid-card': GridCard,
    'adx-textarea': Textarea,
    'adx-list-item': ListItem,
    'adx-loading': LoadingPrimary,
    'adx-loading-spin': LoadingSpin,
    'adx-detail-slider': DetailSlider,
    'adx-barpercentage': BarPercentage,
    'adx-selectdropdown': SelectDropdown,
    'adx-label-custom': LabelStatusCustom,
    'adx-loading-circle': LoadingSecondary,
    'adx-expandable-level2' : ExpandableLevel2,
  },
  props: {

  },
  data() {
    return {
      id: null,
      admin: false,
      scrolling: false,
      isviewOrder: false,
      isAddOrder: false,
      isPreview: false,
      isActive: false,
      isOverview: false,
      isAdvertisement: false,
      isAudience: false,
      isPhotos: false,
      openCustom: false,
      isPreviewModal: false,
      show: false,
      imageIndex: 0,
      isOpen: false,
      descHeight: 0,
      currentSlide: 1,
      countSlide: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      textDesc: 'textDesc',
      spbuDetail: {
        title: ``,
        location: ``,
        type: ``,
        description: ``,
        surrounding: ``,
        forbidden: ``,
        address: ``,
      },
      traffic:{
        visitor: null,
        subject: null,
        spending: null,
        occupation: null,
        visitor_profile: null,
      },
      customAdv:{
        title: null,
        description: null,
        price: null
      },
      content:{
        imgUrl: null,
        imgTitle: null,
        orientation: null
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
      placeholderImage:[{
        id: 0,
        url: `/img/notfound/img-placeholder_landscape.jpg`,
        thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
        is_primary: false,
        caption: 'placeholder'
      }],
      monthlyPeriod: 1,
      period: [],
      wrapperStyle: {
        "height": "270px",
        "width": "100%"
      },
      OperatingHours: [],
      detailSlider: [],
      occupation: ``,
      itemPhoto: [],
      regularPhotos: [],
      genderPercentage:[]
,     agePercentage: [],
      selectedOrders:[],
      images:[],
      itemMedia:[],
      images360: [],
      startDate: null,
      endDate: null
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token',
      account: 'account'
    }),
    isPhotosAvailable(){
      return this.detailSlider.length > 0
    },
    getVisitor: function() {
      return this.traffic.visitor * 30 
    },
    isExBranding:function(){
      for(let el of this.selectedOrders) {
        if(el.media_name == 'Experience Branding Package'){
          this.endDate = this.endDateExBrand
          return true
          break;
        } 
      }
      return false
    },
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    endDateExBrand: function(){
      var end = new Date(this.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + this.monthlyPeriod);
      return end
    },

    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeMount() {
    const { id } = this.$route.params
    this.id = id
    this.loadData()
  },
  mounted() {
    this.admin = this.account.isStaff
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.getDetailSPBU(this.id), { needToken: true })
        this.loadImage(data)
        this.mapData(data)
        this.getPeriod()
        this.setOrderDate()
        this.infoLoaded = true
      })();
    },
    loadImage(data) {
      (async () => {
        this.detailSlider = []
        let image = []
        let isPrimaryExist = false
        data.photos.map(el => {
          if(el.is_primary){
            isPrimaryExist = true
            image.push({
              id: el.id,
              url: el.image,
              is360: el.is_360,
              caption: el.caption,
              viewer_url: el.viewer_url,
              thumbnail : el.thumbnail_720,
              is_primary: el.is_primary,
            })
          }
        })
        this.imgLoaded = true
        if (!isPrimaryExist && data.photos.length > 0){
          let firstPic = data.photos[0]
          this.detailSlider.push({
            id: firstPic.id,
            url: firstPic.image,
            is360: firstPic.is_360,
            caption: firstPic.caption,
            viewer_url: firstPic.viewer_url,
            thumbnail : firstPic.thumbnail_720,
            is_primary: firstPic.is_primary
          })
        } else if (image.length > 0) {
          this.detailSlider.push(image[0])
        }
      })();
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()

        this.period = data.periods
      })();
    },
    setOrderDate() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      this.startDate = nextweek

      var nextweekplus = new Date();
      nextweekplus.setDate(nextweekplus.getDate() + 8);
      this.endDate = nextweekplus
    },
    mapData(data) {
      this.location = data,
      this.itemMedia = data.media

      // mapping 360 photos
      data.photos.map(el =>{
        if(el.is_360){
          this.images360.push({
            url : el.thumbnail_100,
            viewer_url: el.viewer_url,
            is360: el.is_360
          })
        }
      })
      
      //mapping spbu detail
      this.spbuDetail = {
        title: data.title,
        location: data.cluster,
        type: (data.property_type == 'GS' ? 'Gas Station' : ' -'),
        description: data.location_description,
        surrounding: data.surrounding,
        forbidden: (data.street ? data.street : 'There\'s no forbidden ads'),
        address: (data.street ? data.street : 'N/A'),
      }
      let subject = '-'
      if(data.spending_average){
        subject = '/' + data.spending_period + '/' + data.spending_subject
      }
      this.traffic = {
        visitor: data.traffic,
        spending: data.spending_average,
        subject: subject,
        occupation: (data.profile ? ` Occupation ${data.profile.job.join(` `)}` : '-'),
        visitor_profile: (data.profile ? ` Visitor Profile ${data.profile.ses.join(` `)}` : '-'),
      }
      this.OperatingHours = data.operating_hour.map(el => {
        let data = {}
        data.day = el.day
        data.isOpen = el.is_open
        if (el.is_open) {
          data.time = `${el.start} - ${el.end}`
        } else {
          data.time = 'closed'
        }
        return data
      })

      //Gender mapping data
      let gender = data.demographic_gender
      let tempPercentage = []
      if(gender) {     
      Object.keys(gender).forEach(function(key){
        // console.log('key',key, gender[key])
        if(key == 'male'){
          tempPercentage.push({
            header : 'Male',
            percent: gender[key] * 100,
            color : '#ff2d55'
          })
        } else{
          tempPercentage.push({
            header : 'Female',
            percent: gender[key] * 100, 
            color : '#5856d6'
          })
        }
      })   
      this.genderPercentage = tempPercentage
      }

      //Age Mapping
      let age = data.demographic_age
      let tempPercentage2 = []
      if(data.demographic_age){
      Object.keys(age).forEach(function(key){
        if(key == '15 - 24'){
          tempPercentage2.push({
            header : '15-24',
            percent: age[key] * 100,
            color : '#FF2D55'
          })
        }else if(key == '25 - 34'){
          tempPercentage2.push({
            header : '25-34',
            percent: age[key] * 100,
            color : '#FF5777'
          })
        }else if(key == '35 - 44'){
          tempPercentage2.push({
            header : '35-44',
            percent: age[key] * 100,
            color : '#FF8199'
          })
        } else{
          tempPercentage2.push({
            header : '45 - 54',
            percent: age[key] * 100, 
            color : '#FFabbb'
          })
        }
      })   
      this.agePercentage = tempPercentage2
      }
      this.$nextTick(() => {
        var element = this.$refs[this.textDesc]
        this.descHeight = element? element.clientHeight : 0
      })
    },
    getPhotoTitle(title){
      if(title == 'device'){
        return 'Digital Screen'
      }else if(title == 'experience branding') {
        return 'Experience Branding Package'
      } else{
        return 'Others'
      }
    },
    getTotal(){
      let total = 0
      this.selectedOrders.forEach(element => {
        const item = element.include_tax? (element.price / 1.1) : element.price
        total += item
      });
      return total
    },
    getTotalByPPN(){
      return this.getTotal() + (this.getTotal()* 0.1)
    },
    deleteOrder(index){
      this.selectedOrders.splice(index, 1)
    },
    addToOrder(list, item){
      let price = item.include_tax? (item.price / 1.1): item.price
      let media_name = item.media_name == `device`? `Digital Screen`: `Experience Branding Package`
      const ordered = this.selectedOrders.map(x => {
        return x.item_id
      })
      let tempOrder = {
        location_id: list.id,
        item_id: item.id,
        title: list.title,
        price: price,
        media_name: media_name,
      }
      if (ordered.includes(item.id)){
        this.$notify({
          group: 'saved',
          title: 'Error',
          text:  'Item already in order',
          type: 'danger'
        });
      } else {
        this.selectedOrders.push(tempOrder)
      }
      this.isAddOrder = true
    },
    saved() {
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: `Data successfully saved!`,
        type: 'success'
      });
      this.isviewOrder = false
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    },
    toggleOrder(isOpen){
      isOpen == 1 ? this.isviewOrder = true : this.isviewOrder = false
    },
    toggleCustom(isOpen){
      isOpen == 1 ? this.openCustom = true : this.openCustom = false
    },
    showMore(index){
      index == 1 ? this.show = true : this.show = false
    },
    togglePreview(){
      this.isPreview = !this.isPreview
    },
    itemPreview(item){
      this.content = {
        imgUrl: item.photo,
        imgTitle: item.media_name,
        orientation: 'landscape'
      }
      this.isPreview = !this.isPreview
    },
    toggleBanner(image) {
      let tempImage = image
      tempImage[0].is360 ? window.open(tempImage[0].viewer_url) : window.open(tempImage[0].url)
    },
    regularPreview(isOpen, regularPhoto, index){
      if(isOpen == 1 ){
        let tempRegPhotos = []
        if(regularPhoto.length > 0){
          regularPhoto.map( el =>{
            tempRegPhotos.push({
              caption: el.original,
              id: el.original,
              is_primary: false,
              thumbnail: el.original,
              url: el.original
            })
          })
        }
        this.regularPhoto = tempRegPhotos
        this.imageIndex = index
        this.isPreviewModal = true
      } else{
        this.isPreviewModal = false
      }
    },
    goto360Preview(photos){
      window.open(photos)
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      if(refName == 'overview'){
        this.isOverview = true
        this.isAdvertisement = false
        this.isAudience = false
        this.isPhotos = false
      } else if(refName == 'advertisement'){
        this.isOverview = false
        this.isAdvertisement = true
        this.isAudience = false
        this.isPhotos = false
      } else if(refName == 'audience'){
        this.isOverview = false
        this.isAdvertisement = false
        this.isAudience = true
        this.isPhotos = false
      } else{
        this.isOverview = false
        this.isAdvertisement = false
        this.isAudience = false
        this.isPhotos = true
      }
      window.scrollTo({top:top, behavior: 'smooth'})
    },
    handleScroll() {
       window.onscroll = () => {
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        bottomOfWindow ?  this.scrolling = false : this.scrolling = true
     	}
    },
    toggleSave(list, item){
      this.successNotif()
    },
    successNotif(){
      this.$notify({
        group: 'saved',
        title: 'Added to campaign',
        text: "Added to campaign",
        type: 'success'
      });
    }
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.spbu-page{
  .detail-spbu__banner__placeholder {
    .slick-slide {
      margin: 0px;
      img.detail {
        object-fit: unset;
      }
    }
  }

  .img-container {
    .img-overlay{
      img{
        width: 12%;
      }
    }
  }

  .order-summary__wrapper__top{
    .selectDropdown{
      width: 50%;
    }
  }

  .detail-spbu__banner__img {

    .slick-slide {
      width: 100;
    }
    .slick-slide:first-child{
      margin-left: 0px;
    }
  }

  .modal__content__header{
    .title{
      font-size: 28px;
    }
  }
}


@include breakpoint(md) {

.spbu-page{
  .detail-spbu__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }

  .modal__content.small{
    top: 0px;
    height: 100%;
    width: 100%;
  }

  .modal__content__header{
    display: block;

    button{
      display: unset;
    }
    .title{
      font-size: 24px;
      margin-left: 16px;
    }
  }
  .gridCard{
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 1fr));
    gap: 8px 8px;
  }

  .order-summary__wrapper__top{
    .selectDropdown{
      width: 100%;
    }
  }
}

.spbu-page{
    .detail-spbu__banner__placeholder {
      .slick-slide {
        img.detail {
          height: 260px;
        }
      }
    }
  }

.spbu-page{
  .expandableList__card__channels__content__left__place-image{
    img{
      height: 200px;
    }
  } 
}
}
</style>
